import { create } from 'zustand';
import { FeaturesByVersionMap } from '../../../data-access/gql-types/graphql';

type VersionMapStore = {
  versionMap: FeaturesByVersionMap[];
  setVersionMap: (versionMap: FeaturesByVersionMap[]) => void;
};

export const useVersionMapStore = create<VersionMapStore>()((set) => ({
  versionMap: [],
  setVersionMap: (versionMap: FeaturesByVersionMap[]) => set(() => ({ versionMap })),
}));
